export default {
  shifts: []
};
